import React, { useState, useContext } from "react"

import Style from "./media.module.scss"
import Styled from "styled-components"

import { MediaPopUpContext } from "../../contexts/MediaPopUp"

/**
 * MediaThumbnail --- Component representing a single
 * thumbnail for a piece of video media
 */
export const MediaThumbnail = props => {
  // Thumbnail state: either a still image or a GIF on hover
  const [thumbNail, setThumbnail] = useState(props.media.gifStill.file.url)

  // Meta data background and text color state on hover
  const [metaDataBackground, setMetaDataBackground] = useState("#FFFFFF")
  const [metaDataText, setMetaDataText] = useState(props.color)

  // Video pop up  context for visibility
  const [popUpData, setPopUpData] = useContext(MediaPopUpContext)

  let gifUrl =
    props.media.mediaType === "Video"
      ? props.media.gifUrl
      : props.media.gifStill.file.url

  return (
    <>
      <button
        className={Style.articleMedia}
        style={{ top: props.top }}
        onClick={() =>
          setPopUpData({ visibility: "visible", content: props.media })
        }
        onMouseEnter={() => {
          setThumbnail(gifUrl)
          setMetaDataBackground(props.color)
          setMetaDataText("#FFFFFF")
        }}
        onMouseLeave={() => {
          setThumbnail(props.media.gifStill.file.url)
          setMetaDataBackground("#FFFFFF")
          setMetaDataText(props.color)
        }}
      >
        <div className={Style.thumbnailWrapper}>
          <div
            className={Style.metaDataTagWrapper}
            style={{ textAlign: "left" }}
          >
            {/** Meta data tag for video thumbnails */}
            <MetaDataTag color={metaDataText} background={metaDataBackground}>
              {props.media.thumbnailMetadata.map((thumbnailMetadata, id) => (
                <>
                  <b>
                    {thumbnailMetadata
                      .substr(0, thumbnailMetadata.indexOf(":") + 1)
                      .toUpperCase()}
                  </b>
                  <span>
                    {thumbnailMetadata.substr(
                      thumbnailMetadata.indexOf(":") + 1,
                      thumbnailMetadata.length
                    )}
                  </span>
                  <br />
                </>
              ))}
            </MetaDataTag>
          </div>
          {/** Image/GIF wrapper and src */}
          <div
            style={{
              position: "relative",
            }}
          >
            <img
              src={thumbNail}
              width="100%"
              height="100%"
              alt="Article Video"
            />
          </div>
        </div>
      </button>
    </>
  )
}

/* ===================================================*/

/**
 * MetaDataTag: Styled component
 * for meta data on thumbnail in order
 * to specify font color and float
 */
const MetaDataTag = Styled.div`
    font-size: 0.9vw;
    b {
        color: ${props => props.color};
        background-color: ${props => props.background};
        padding-top: 0.3vw;
        padding-left: 0.2vw;
        padding-right: 0.2vw;
    }
    span {
        background-color: ${props => props.background};
        padding-top: 0.3vw;
        padding-left: 0.2vw;
        padding-right: 0.2vw;    
    }
    /**
    * iPads
    */
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
        font-size: 1.1vw;
    }
`

// TODO 5: Refactor all iframe stylings from components like this one
export const BandCampPlayerLarge = props => {
  return (
    <div
      className={Style.articleMedia}
      style={{ width: "100%", height: "83%", top: "3vw" }}
    >
      <iframe
        title="Bandcamp Player"
        src={props.media.url + "/linkcol=" + props.color.substr(1)}
        seamless
        style={{
          position: "relative",
          border: "0",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
        }}
        allowFullScreen
        allow="encrypted-media"
      ></iframe>
    </div>
  )
}

/* ===================================================*/

export const BandCampSmall = props => {
  return (
    <div className={Style.articleMedia}>
      <iframe
        title="Bandcamp Player"
        src={props.media.url + "/linkcol=" + props.color.substr(1)}
        className={Style.bandCampSmall}
        allowFullScreen
        allow="encrypted-media"
      ></iframe>
    </div>
  )
}

/* ===================================================*/

export const SoundCloudSmall = props => {
  return (
    <div className={Style.articleMedia}>
      <iframe
        title="SoundCloud Player"
        src={props.media.url + `&color=${props.color.substr(1)}`}
        width="100%"
        height="120vw"
        scrolling="no"
        frameBorder={0}
        allow="encrypted-media"
      ></iframe>
    </div>
  )
}

/* ===================================================*/

export const SoundCloudMedium = props => {
  return (
    <div className={Style.articleMedia} style={{ top: props.top }}>
      <iframe
        title="SoundCloud Player"
        src={props.media.url + `&color=${props.color.substr(1)}`}
        width="100%"
        height="100%"
        scrolling="no"
        frameBorder={0}
        allow="encrypted-media"
      ></iframe>
    </div>
  )
}

/* ===================================================*/

export const Image = props => {
  return (
    <div className={Style.articleMedia}>
      <a href={props.media.url} target={"_blank"} rel="noopener noreferrer">
        <img src={props.media.image.file.url} alt={props.media.image.title} />
      </a>
    </div>
  )
}
